import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

const BreadCrumb = ({ nested }) => {
    return (
        <nav aria-label="breadcrumb">
            <ol className="breadcrumb">
                <li className="breadcrumb-item section-title pt-1  text-decoration-none">
                    <a className="text-decoration-none " href="/">Home</a>
                </li>
                <li className="" aria-current="page">
                    <span className="mx-md-2 mx-1 ">
                        <FontAwesomeIcon icon={faChevronRight} />
                    </span>   <span className="nested-link">{nested}</span> </li>
            </ol>
        </nav>
    );
};

export default BreadCrumb;